.container {
    min-height: 60vh;
    background-color: #0d0a13;
    background-image: linear-gradient(to bottom, #1c1428 0px, #140f1d 320px, #0d0a13 720px);
    background-repeat: no-repeat;
}

.titleContainer {
    position: relative;
    overflow: hidden;
    display: flex;
    height: 760px;
    justify-content: flex-start;
    align-items: center;
}

.titleContainerMob {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 760px;
    justify-content: center;
    align-items: center;
}

/* --- hero background layer --- */
.heroBg {
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
}

.heroSvg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}

.heroFade {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 280px;
    background: linear-gradient(to bottom, rgba(13, 10, 19, 0) 0%, #0d0a13 88%);
}

/* --- floating todo cards --- */
.todoCard {
    position: absolute;
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 12px 15px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.055);
    border: 1px solid rgba(168, 85, 247, 0.32);
    backdrop-filter: blur(7px);
    -webkit-backdrop-filter: blur(7px);
    box-shadow: 0 16px 34px rgba(10, 6, 20, 0.4);
    z-index: 1;
    pointer-events: none;
}

.todoCheck {
    width: 24px;
    height: 24px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.checkGreen {
    background: #94df21;
}

.checkPurple {
    background: #a855f7;
}

.checkEmpty {
    border: 2px solid rgba(200, 180, 230, 0.5);
}

.todoText {
    font-size: 14px;
    font-weight: 600;
    color: #f1e9ff;
    font-family: var(--font-body);
}

.todoDone {
    color: rgba(230, 213, 255, 0.55);
    text-decoration: line-through;
}

.todoSub {
    margin-top: 3px;
    font-size: 11px;
    color: rgba(230, 213, 255, 0.45);
    font-family: var(--font-body);
}

.todo1 {
    left: 41%;
    top: 13%;
}

.todo2 {
    left: 45%;
    top: 44%;
}

.todo3 {
    left: 38%;
    bottom: 15%;
}

.todo4 {
    right: 7%;
    top: 22%;
}

/* --- hero text --- */
.title {
    font-size: 5.3em;
    font-family: var(--font-display);
    margin: 0;
    color: #ffffff;
    text-align: justify;
    font-weight: 1000;
    letter-spacing: -2px;
    text-shadow: 0 2px 22px rgba(0, 0, 0, 0.55);
}

.description {
    display: block;
    font-family: var(--font-serif);
    font-size: 2em;
    margin-top: 13px;
    font-style: italic;
    color: #e6d5ff;
    font-weight: 500;
}

.heroChip {
    display: inline-block;
    margin-top: 22px;
    padding: 8px 18px;
    border-radius: 100px;
    background: #a855f7;
    color: #160f1f;
    font-size: 14px;
    font-weight: 700;
    font-family: var(--font-body);
}

.titleContent {
    padding-left: 8%;
}

/* the mobile layout is one column, the title block is centered in it */
.titleContentMob {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-self: center;
    align-items: center;
    text-align: center;
}

.titleContentMob .title {
    text-align: center;
}

.titleContent, .titleContentMob {
    position: relative;
    z-index: 2;
}

/* --- hero device --- */
.heroPhone {
    position: absolute;
    left: 70%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 252px;
    height: 546px;
    border-radius: 40px;
    background: #0b0d10;
    border: 3px solid #2a2136;
    box-shadow: 0 34px 70px rgba(0, 0, 0, 0.6);
    z-index: 2;
    overflow: hidden;
}

.heroPhoneGlow {
    position: absolute;
    left: 70%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 470px;
    height: 470px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(168, 85, 247, 0.3), rgba(168, 85, 247, 0) 66%);
    z-index: 0;
    pointer-events: none;
}

.heroScreen {
    position: absolute;
    inset: 6px;
    width: calc(100% - 12px);
    height: calc(100% - 12px);
    border-radius: 34px;
    object-fit: cover;
    display: block;
}

.heroPhoneMob {
    position: relative;
    z-index: 1;
    width: 230px;
    height: 498px;
    border-radius: 38px;
    background: #0b0d10;
    border: 3px solid #2a2136;
    box-shadow: 0 24px 50px rgba(0, 0, 0, 0.6);
    overflow: hidden;
}

/* the box of the phone, the todo cards are placed on its sides */
.heroPhoneBoxMob {
    position: relative;
    z-index: 1;
    margin-top: 24px;
}

.heroPhoneBoxMob .todoCard {
    width: max-content;
}

.heroPhoneBoxMob .todo1 {
    left: auto;
    right: calc(100% + 28px);
    top: 10%;
}

.heroPhoneBoxMob .todo2 {
    left: calc(100% + 28px);
    top: 28%;
}

.heroPhoneBoxMob .todo3 {
    left: auto;
    right: calc(100% + 14px);
    bottom: 20%;
}

.heroPhoneBoxMob .todo4 {
    right: auto;
    left: calc(100% + 16px);
    top: 62%;
}

/* no room for the cards next to the phone */
@media (max-width: 720px) {
    .heroPhoneBoxMob .todoCard {
        display: none;
    }
}

/* --- work description / about --- */
.workDescriptionBox {
    display: flex;
    justify-content: center;
}

.workDescription {
    margin: 0;
    max-width: 500px;
    min-width: 300px;
    font-size: 1em;
    word-spacing: 5px;
    text-align: justify-all;
    line-height: 28px;
    font-family: var(--font-serif);
}

.workDescription strong {
    color: #7c3aed;
}

/* --- AboutProject composite visual --- */
.aboutStage {
    position: relative;
    width: 470px;
    height: 560px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.aboutGlow {
    position: absolute;
    width: 380px;
    height: 380px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(168, 85, 247, 0.38), rgba(168, 85, 247, 0) 68%);
    filter: blur(4px);
}

.aboutPhone {
    position: relative;
    width: 232px;
    height: 504px;
    border-radius: 36px;
    background: #0b0d10;
    border: 3px solid #2a2136;
    box-shadow: 0 34px 64px rgba(30, 10, 50, 0.28);
    transform: perspective(1300px) rotateY(-16deg) rotate(1deg);
    overflow: hidden;
}

.aboutScreen {
    position: absolute;
    inset: 6px;
    width: calc(100% - 12px);
    height: calc(100% - 12px);
    border-radius: 30px;
    object-fit: cover;
    display: block;
}

.aboutTag {
    position: absolute;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 13px;
    border-radius: 12px;
    background: #ffffff;
    border: 1px solid #efe9f6;
    box-shadow: 0 14px 30px rgba(40, 10, 60, 0.16);
    color: #6b21a8;
    font-size: 13px;
    font-weight: 600;
    font-family: var(--font-body);
    white-space: nowrap;
    z-index: 3;
}

.aboutTag1 {
    top: 6%;
    right: 2%;
}

.aboutTag2 {
    top: 45%;
    right: -4%;
}

.aboutTag3 {
    bottom: 12%;
    left: 0;
}

@media (max-width: 1200px) {
    .titleContainerMob {
        box-sizing: border-box;
        height: auto;
        min-height: 760px;
        padding: 40px 16px;
    }
}

@media (max-width: 600px) {
    .title {
        font-size: 3.4em;
    }

    .description {
        font-size: 1.4em;
    }

    .workDescription {
        min-width: 0;
    }
}
